export default "__VITE_ASSET__6SxDFLMP__"